<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">സമർപ്പിച്ച അപേക്ഷകൾ</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section pt-1" v-else>
        <p class="sneha-page-note mal-text" v-if="applications.length">
            ഈ ശാഖയിൽ സമർപ്പിച്ച അപേക്ഷകൾ ({{ applications.length }})
        </p>

        <div v-if="!applications.length" class="sneha-empty-apps mal-text">
            ഇതുവരെ അപേക്ഷകൾ ഇല്ല.
        </div>

        <div v-else class="sneha-app-list">
            <div v-for="app in applications" :key="app.id" class="sneha-app-item">
                <router-link :to="applicationDetailPath(app.id)" class="sneha-app-link">
                    <div class="sneha-app-main">
                        <span class="sneha-app-name mal-text">{{ app.name }}</span>
                        <span v-if="app.application_number" class="sneha-app-number">{{ app.application_number }}</span>
                        <span class="sneha-app-program mal-text">{{ app.program_title }}</span>
                        <span class="sneha-app-meta mal-text" v-if="app.contact">ഫോൺ: {{ app.contact }}</span>
                        <span class="sneha-app-meta mal-text" v-if="app.created_at">തീയതി: {{ app.created_at }}</span>
                        <span v-if="app.verification_status && app.verification_status !== 'pending'"
                            class="badge mt-1 align-self-start" :class="statusBadgeClass(app.verification_status)">
                            {{ statusLabel(app.verification_status) }}
                        </span>
                        <span class="sneha-app-meta mal-text text-danger"
                            v-if="app.verification_notes && ['not_verified', 'edit_requested'].includes(app.verification_status)">
                            Note: {{ app.verification_notes }}
                        </span>
                    </div>
                    <ion-icon name="chevron-forward-outline" class="sneha-app-chevron"></ion-icon>
                </router-link>
                <router-link
                    v-if="app.verification_status !== 'verified'"
                    :to="applicationEditPath(app.id)"
                    class="sneha-app-edit-btn"
                >
                    <ion-icon name="create-outline"></ion-icon>
                    <span class="mal-text">എഡിറ്റ്</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparshamApplicationList",
    data() {
        return {
            loading: true,
            applications: [],
        };
    },
    mounted() {
        this.$root.updateParent("സമർപ്പിച്ച അപേക്ഷകൾ");
        this.loadApplications();
    },
    activated() {
        this.loadApplications();
    },
    methods: {
        statusLabel(s) {
            return s === 'verified' ? 'Verified'
                : s === 'not_verified' ? 'Not Verified'
                : s === 'edit_requested' ? 'Edit Requested'
                : s === 'resubmitted' ? 'Resubmitted' : s;
        },
        statusBadgeClass(s) {
            return s === 'verified' ? 'bg-success'
                : s === 'resubmitted' ? 'bg-info'
                : 'bg-danger';
        },
        applicationDetailPath(applicationId) {
            return `/org/${this.$route.params.sub_level}/${this.$route.params.id}/sneha-sparsham-application/${applicationId}`;
        },
        applicationEditPath(applicationId) {
            return `${this.applicationDetailPath(applicationId)}/edit`;
        },
        loadApplications() {
            const unitId = parseInt(this.$route.params.id, 10);
            if (!unitId) {
                this.applications = [];
                this.loading = false;
                return;
            }

            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-report", {
                user_level: 4,
                user_level_id: unitId,
            }).then((res) => {
                if (res.data.status === "success") {
                    this.applications = res.data.data.list || [];
                } else {
                    this.applications = [];
                }
            }).catch(() => {
                this.applications = [];
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style scoped>
.sneha-page-note {
    margin: 0 0 14px;
    padding: 0 4px;
    font-size: 0.9rem;
    color: #6c757d;
    line-height: 1.45;
}

.sneha-empty-apps {
    text-align: center;
    padding: 24px 12px;
    color: #6c757d;
    font-size: 0.92rem;
    background: #fff;
    border-radius: 10px;
    border: 1px dashed #ced4da;
}

.sneha-app-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sneha-app-item {
    display: flex;
    align-items: stretch;
    gap: 8px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.sneha-app-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    text-decoration: none;
    flex: 1;
    min-width: 0;
    transition: background-color 0.15s ease;
}

.sneha-app-link:active {
    background: #f8f9fa;
}

.sneha-app-edit-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 8px 12px;
    text-decoration: none;
    color: #1a418c;
    background: #f4f7ff;
    border-left: 1px solid #dee2e6;
    font-size: 0.72rem;
    flex-shrink: 0;
}

.sneha-app-edit-btn ion-icon {
    font-size: 18px;
}

.sneha-app-edit-btn:active {
    background: #e8eeff;
}

.sneha-app-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.sneha-app-name {
    font-size: 0.98rem;
    font-weight: 600;
    color: #1a418c;
    line-height: 1.35;
    word-break: break-word;
}

.sneha-app-number {
    display: inline-block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: #6b7c93;
    background: #f4f7ff;
    border: 1px solid #dde4f5;
    border-radius: 5px;
    padding: 1px 6px;
    margin-top: 2px;
    width: fit-content;
}

.sneha-app-program {
    font-size: 0.86rem;
    color: #6c757d;
    line-height: 1.35;
}

.sneha-app-meta {
    font-size: 0.82rem;
    color: #495057;
    line-height: 1.35;
}

.sneha-app-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
</style>
